import * as React from 'react';
import { ThemeContext } from 'styled-components';
import 'date-fns/locale';
import 'polished';
import '../colors/colors.js';
import './seismic/global.js';

var useThemeContext = function useThemeContext() {
  return React.useContext(ThemeContext);
};

export { useThemeContext };
